"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureFlagCategoryDisplay = exports.FeatureFlagCategory = void 0;
var FeatureFlagCategory;
(function (FeatureFlagCategory) {
    FeatureFlagCategory[FeatureFlagCategory["RELEASED"] = 0] = "RELEASED";
    FeatureFlagCategory[FeatureFlagCategory["UPGRADE"] = 1] = "UPGRADE";
    FeatureFlagCategory[FeatureFlagCategory["BETA"] = 2] = "BETA";
    FeatureFlagCategory[FeatureFlagCategory["UNDER_DEVELOPMENT"] = 3] = "UNDER_DEVELOPMENT";
})(FeatureFlagCategory || (exports.FeatureFlagCategory = FeatureFlagCategory = {}));
exports.FeatureFlagCategoryDisplay = {
    [FeatureFlagCategory.RELEASED]: "Released",
    [FeatureFlagCategory.UPGRADE]: "Upgrade",
    [FeatureFlagCategory.BETA]: "Beta",
    [FeatureFlagCategory.UNDER_DEVELOPMENT]: "Under Development",
};
